// @ts-nocheck
import { UserManagementService } from './UserManagementService';
import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../../queries/useDataEngine';
import { EMPTY_OBJECT } from '../../../../const/CommonConst';
import { TASKS_QUERY_KEYS } from '../../../home/tasks/api/tasksQueries';
import { RESOURCE_PLANNING_QUERY_KEYS } from '../../../home/resourcePlanning/api/resourcePlanningQueries';

const USER_MANAGEMENT = 'user_management';

export const USER_MANAGEMENT_QUERY_KEYS = {
  ALL: [USER_MANAGEMENT],
  groups: {
    ROOT: [USER_MANAGEMENT, 'groups'],
    key: (params = {}) => [USER_MANAGEMENT, 'groups', params],
  },
  groupTasks: {
    ROOT: [USER_MANAGEMENT, 'groupTasks'],
    key: (params = {}) => [USER_MANAGEMENT, 'groupTasks', params],
  },
  users: {
    ROOT: [USER_MANAGEMENT, 'users'],
    key: (params = {}) => [USER_MANAGEMENT, 'users', params],
  },
};

export const useGroupsQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  const { select, ...restOptions } = options;
  return useNewQueryEngine(
    USER_MANAGEMENT_QUERY_KEYS.groups.key,
    UserManagementService.getGroups,
    params,
    {
      ...restOptions,
      select: (data) => {
        const groups = data?.Groups;
        return select ? select(groups) : groups;
      },
    }
  );
};

export const useUsersQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    USER_MANAGEMENT_QUERY_KEYS.users.key,
    UserManagementService.getAllUsers,
    params,
    options
  );
};

export const useGroupTasksQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    USER_MANAGEMENT_QUERY_KEYS.groupTasks.key,
    UserManagementService.getGroupTasks,
    params,
    options
  );
};

export const useCreateGroupMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(UserManagementService.createGroup, {
    ...options,
    invalidateQueries: [USER_MANAGEMENT_QUERY_KEYS.groups.ROOT],
  });
};

export const useUpdateGroupMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(UserManagementService.updateGroup, {
    ...options,
    invalidateQueries: [USER_MANAGEMENT_QUERY_KEYS.groups.ROOT],
  });
};

export const useDeleteGroupMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(UserManagementService.deleteGroup, {
    ...options,
    invalidateQueries: [USER_MANAGEMENT_QUERY_KEYS.groups.ROOT],
  });
};

export const useAssignTaskMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(UserManagementService.assignTask, {
    ...options,
    invalidateQueries: [
      USER_MANAGEMENT_QUERY_KEYS.groupTasks.ROOT,
      TASKS_QUERY_KEYS.openTasks.ROOT,
      RESOURCE_PLANNING_QUERY_KEYS.teamMembersWithEffort.ROOT,
      RESOURCE_PLANNING_QUERY_KEYS.userTaskDetails.ROOT,
      RESOURCE_PLANNING_QUERY_KEYS.openTaskCount.ROOT,
    ],
  });
};
